import { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as IconCopy } from 'assets/svgs/icn-copy-icon.svg';
import { ReactComponent as IconCheck } from 'assets/svgs/icn-checkbox-checked.svg';
import { useTheme } from 'hooks';
import { TRANSLATIONS_VALUES_KEYS } from 'redux/internationalization/internationalization';
import { useTranslate } from 'services';
import { defaultStyles } from 'hooks/useTheme/useTheme.util';

const { validation_wrapper } = TRANSLATIONS_VALUES_KEYS;

const CopyLinkWrapper = styled.div<{ color: string }>`

  & .svg {
    height: 1rem;
    padding-right: 0.313rem;
  }

  & .row-two__row1 {
    text-align: center;
    padding-top: 0.625rem;
    width: 13rem;
    font-size: 0.813rem;
    font-weight: 600;
  }

  & .row-two__row2 {
    margin-top: 0.375rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.75rem;

    & .icn-copied {
      fill: ${({ color }) => color};
    }
  }
`;

const CopyLink = () => {
  const { styles } = useTheme();
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const { translate } = useTranslate();

  const getValidatedCopyLinkUrlParam = () => {
    const copyLinkUrlParam = new URLSearchParams(window.location.search).get('copyLinkUrl');
    if (!copyLinkUrlParam) {
      return null;
    }

    try {
      const parsed = new URL(copyLinkUrlParam);
      return parsed.protocol === 'https:' ? parsed.href : null;
    } catch {
      return null;
    }
  };

  const copyWithExecCommand = (url: string): boolean => {
    const node = document.createElement('textarea');
    document.body.appendChild(node);
    node.value = url;
    node.select();
    const succeeded = document.execCommand('copy');
    document.body.removeChild(node);
    return succeeded;
  };

  const copyLink = async () => {
    const url = getValidatedCopyLinkUrlParam() || window.location.href;
    let succeeded = false;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        succeeded = true;
      } catch {
        // Clipboard API can reject in cross-origin iframes without clipboard-write permission
        succeeded = copyWithExecCommand(url);
      }
    } else {
      succeeded = copyWithExecCommand(url);
    }

    if (succeeded) {
      setIsLinkCopied(true);
    }
  };

  return (
    <CopyLinkWrapper color={isLinkCopied ? styles.colorSuccess : styles.colorParagraph} role="button" tabIndex={0} onClick={() => copyLink()}>
      <div className="row-two__row1">
        { translate(validation_wrapper.copy_link_instruction_text) }
      </div>
      <div className="row-two__row2">
        {isLinkCopied ? <IconCheck className="icn-copied svg" /> : <IconCopy className="svg" />}
        {
          isLinkCopied
            ? translate(validation_wrapper.linkCopied_text)
            : <b style={{ color: defaultStyles.colorPrimaryButtonBackground }}>{translate(validation_wrapper.copy_link_text)}</b>
        }
      </div>
    </CopyLinkWrapper>
  );
};

export default CopyLink;
